var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScientificSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 3C8.25 2.58579 8.58579 2.25 9 2.25H15C15.4142 2.25 15.75 2.58579 15.75 3C15.75 3.41421 15.4142 3.75 15 3.75H9C8.58579 3.75 8.25 3.41421 8.25 3Z",
    fill: "#0073AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 9C9.25 8.58579 9.58579 8.25 10 8.25H14C14.4142 8.25 14.75 8.58579 14.75 9C14.75 9.41421 14.4142 9.75 14 9.75H10C9.58579 9.75 9.25 9.41421 9.25 9Z",
    fill: "#0073AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99895 2.25C10.4132 2.25 10.749 2.58579 10.749 3V9C10.749 9.08741 10.7337 9.17416 10.7038 9.25631L6.70609 20.25H17.2918L13.2941 9.25631C13.2642 9.17416 13.249 9.08741 13.249 9V3C13.249 2.58579 13.5847 2.25 13.999 2.25C14.4132 2.25 14.749 2.58579 14.749 3V8.86787L18.692 19.7112C18.7779 19.9001 18.8224 20.1054 18.8221 20.3133C18.8219 20.5378 18.7695 20.7592 18.669 20.96C18.5686 21.1609 18.4229 21.3356 18.2435 21.4706C18.064 21.6055 17.8557 21.6969 17.6348 21.7376C17.59 21.7458 17.5445 21.75 17.499 21.75H6.49895C6.45337 21.75 6.40789 21.7458 6.36306 21.7376C6.14224 21.6969 5.93389 21.6055 5.75443 21.4706C5.57496 21.3356 5.42928 21.1609 5.32886 20.96C5.22845 20.7592 5.17604 20.5378 5.17578 20.3133C5.17554 20.1054 5.22001 19.9 5.30594 19.7112L9.24895 8.86787V3C9.24895 2.58579 9.58474 2.25 9.99895 2.25Z",
    fill: "#0073AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientificSelected);
export default __webpack_public_path__ + "static/media/scientific-selected.d31bbbf3027503d6b84f468761f8925e.svg";
export { ForwardRef as ReactComponent };